jQuery(document).ready(function($) {
  if ( $('.o-front-hero')[0] ) {
    $('.o-front-hero__image').parallax({
      friction  : "0.1",
      block     : $('#content'),
      direction : "down",
      origin    : "top",
      scrollgate: "true"
    });
  }
});